import React from "react";
import { Link } from "react-router-dom";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="brand-name">Monagora</span>
              <span className="hero-subtitle">Logiciel de Gestion Intelligent</span>
            </h1>
            
            <div className="hero-features">
              <div className="feature-card">
                <div className="feature-content">
                  <h3>RDV Automatiques</h3>
                  <p>Prise de rendez-vous automatisée avec envoi d'emails personnalisés à vos clients</p>
                </div>
              </div>
              
              <div className="feature-card">
                <div className="feature-content">
                  <h3>IA Optimisée</h3>
                  <p>Intelligence artificielle qui optimise votre planning en temps réel pour maximiser votre efficacité</p>
                </div>
              </div>
              
              <div className="feature-card">
                <div className="feature-content">
                  <h3>Gain de Temps</h3>
                  <p>3h économisées par jour grâce à l'automatisation complète de votre gestion de planning</p>
                </div>
              </div>
              
              <div className="feature-card">
                <div className="feature-content">
                  <h3>Économies Réelles</h3>
                  <p>Réduction de 40% des coûts opérationnels grâce à l'optimisation des trajets et du temps</p>
                </div>
              </div>
            </div>
            
            <div className="hero-actions">
              <Link to="/automatique" className="cta-button primary">
                Récupérer du Temps
              </Link>
              <Link to="/ia-vs-humain" className="cta-button secondary">
                IA vs Humain
              </Link>
              <Link to="/gains-financiers" className="cta-button tertiary">
                Gains Financiers
              </Link>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="dashboard-mockup">
              <div className="mockup-header">
                <div className="mockup-controls">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="mockup-title">Monagora Dashboard</div>
              </div>
              <div className="mockup-content">
                <div className="hero-stats">
                  <div className="stat-item">
                    <span className="stat-number">Temps gagné</span>
                    <span className="stat-label">Automatisation complète</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">Coûts réduits</span>
                    <span className="stat-label">Économies significatives</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">Disponibilité</span>
                    <span className="stat-label">24h/24 et 7j/7</span>
                  </div>
                </div>
                <div className="mockup-calendar">
                  <div className="calendar-header">Planning IA</div>
                  <div className="calendar-grid">
                    {[...Array(12)].map((_, i) => (
                      <div key={i} className="calendar-slot"></div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero-background">
        <div className="gradient-blob blob-1"></div>
        <div className="gradient-blob blob-2"></div>
        <div className="gradient-blob blob-3"></div>
      </div>
    </section>
  );
};

export default HeroSection; 